<template>
    <div class="modal-goodslist">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">菜单排序</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">
                <el-tree
                    :data="data"
                    node-key="Code"
                    default-expand-all
                    @node-drop="handleDrop"
                    draggable
                    :allow-drop="allowDrop"
                    :expand-on-click-node="false">
                </el-tree>
            </div>
            <div class="modal-footer">
                <el-button :loading="loading"  type="primary" @click="save()">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Add',
        props: ["listMenuDTO"],
        data() {
            return {

                loading: false,

                data:[]
            }
        },

        methods: {
            init(){
                console.log(this.listMenuDTO)
                let aa =  JSON.stringify(this.listMenuDTO).replace(/name/g,"label");
                this.data = JSON.parse(aa);
            },
            handleDrop(draggingNode, dropNode, dropType, ev) {
                let selfCode = draggingNode.data.menuCode;
                console.log(this.listMenuDTO)
                let parentCode = dropNode.data.menuCode;
                this.listMenuDTO=this.sort(this.listMenuDTO,parentCode,selfCode,dropType);
                console.log(this.listMenuDTO)
                console.log(ev)
            },
            sort(list,parentCode,selfCode,dropType){
                var selfSub=-1,parentSub=-1,item;
                for(let i in list){
                    if(list[i].menuCode==selfCode){
                        selfSub=i
                    }
                    if(list[i].menuCode==parentCode){
                        parentSub=i
                    }
                    if(selfSub>=0&&parentSub>=0){
                        if(dropType=='before'){
                            item = list.splice(selfSub, 1)
                            item[0].sort=list.length-parentSub
                            if(parentSub==0){
                                list.unshift(item[0])
                            }else{
                                list.splice(parentSub, 0, item[0])
                            }
                            for(let j in list){
                                list[j].sort=list.length-j;
                            }
                        }
                        console.log(list);
                        selfSub=-1;
                        parentSub=-1
                    }
                    if(list[i].children){
                        if(!item&&list[i].children.length>0){
                            var listChildren=this.sort(list[i].children,parentCode,selfCode,dropType);
                            console.log(listChildren)
                            list[i].children=listChildren;
                        }
                    }
                }
                return list;
            },
            closeSelf() {
                this.$emit("closeSort");
            },
            allowDrop(draggingNode, dropNode, type) {
                if(draggingNode.level === dropNode.level){
                    if(draggingNode.parent.id === dropNode.parent.id){
                        return type === 'prev'
                    }
                }else{
                    // 不同级进行处理
                }
            },

            save(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }


                let aa = JSON.stringify(this.listMenuDTO);
                aa = aa.replace(/children/g, "listMenu");

                let data = {
                    timeStr:timeStr,
                    sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    staffCode:getStaffCode(),
                    listMenu:JSON.parse(aa)
                };


                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Menu/Edit",
                    data:data
                }).then(
                    (response) => {
                        console.log(JSON.stringify(response.data));
                        this.loading = false;

                        if (response.data.error == 0) {
                            this.$message({type: 'success', message: '排序成功'});
                            this.$emit("closeSort");
                            this.$emit("menuShow");
                        }else{
                            this.$message({type: 'success', message: '排序失败'});
                        }
                    }
                )

            }



        }
    }


</script>





<style lang="scss" scoped>

    .modal-goodslist {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow: 2px 2px 20px 1px;
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 600px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                overflow-y:scroll;
                height: 300px;
            }
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
